import React from 'react';

const ClockIcon = ({ fill = '#5AA832'}) => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Report-Builder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Custom-Reports---Untitled-Added" transform="translate(-790.000000, -596.000000)">
          <g id="Report-List---Custom-Reports" transform="translate(254.000000, 242.000000)">
            <g id="Transaction" transform="translate(0.000000, 241.000000)">
              <g id="Row" transform="translate(1.000000, 92.000000)">
                <g id="Scheduled-Text" transform="translate(535.000000, 21.000000)">
                  <g id="icon-clock">
                    <circle id="Oval-3" stroke={fill} strokeWidth="1" cx="8" cy="8" r="7" />
                    <rect id="Rectangle-3" fill={fill} x="7.45" y="3" width="1" height="6" rx="1" />
                    <rect id="Rectangle-17" fill={fill} transform="translate(9.004903, 9.004903) rotate(-315.000000) translate(-9.004903, -9.004903) " x="7.00490303" y="8.50490303" width="5" height="1" rx="1" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ClockIcon;
